<template>
    <li class="page_category__li page_category__sec">
        <slot :childOpen="isOpen" :toggleProps="toggle"></slot>
    </li>
</template>

<script>
export default {
    props: ['isActive'],
    data() {
        return {
            isOpen: false,
        };
    },
    mounted() {
        this.isOpen = this.isActive;
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },
    },
};
</script>

<style lang="scss">
.fade-leave {
    opacity: 1;
}
.fade-leave-active {
    transition: opacity 0.2s;
}
.fade-leave-to {
    opacity: 0;
}
.fade-enter {
    opacity: 0;
}
.fade-enter-active {
    transition: opacity 0.2s;
}
.fade-enter-to {
    opacity: 1;
}
</style>
